import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';

/**
 * TODO: そもそも発注機能自体をバックエンドに持っていくので、そこで内包されたらこれは消す
 * NOTE: 未出力の発注ページにも同様のUseCaseが存在しますが、そのページは後ほど削除するためCoreには入れていません
 * 発注/未発注フラグを更新する
 */
export class UpdateOutputFlagUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注/未発注フラグを更新する
   * @param orderIds - 発注ID
   * @param isOutput - trueなら出力済み、falseなら未出力(出力日時をクリア)にする
   */
  public async Execute(orderIds: string[], isOutput = true): Promise<INetworkResult<string[], Error>> {
    try {
      const response = await this.repository.updateOutputFlag({
        orderIds: orderIds,
        isOutput: isOutput,
      });
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }
      return {
        status: {
          type: 'success',
          data: [],
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
